import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { MasterData, MasterDataResponse } from '../models/masterdata';
import { BaseService } from './base.service';

export type AvailableMasterData = 'locations' | 'counties';

@Injectable({
  providedIn: 'root'
})
export class MasterDataService extends BaseService {
  public dataLoaded: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);

  loadedData: Record<AvailableMasterData, boolean> = {
    counties: false,
    locations: false,
  }

  async getMasterData(name: AvailableMasterData) {
    const key = `masterdata-${name}`;
    // get the data from cache.
    const item = localStorage.getItem(key);

    if (item) {
      const cachedItem = JSON.parse(item);
      const age = (Date.now() - cachedItem.time) / 1000;

      // If TTL didn't expire, return cached data.
      if (age < 3600) {
        return cachedItem.data as MasterData[];
      }
    }

    // If no data is available or TTL expired, reload them from the server and cache them.
    const value = await this.http.get<MasterDataResponse>(`${this.apiUrl}/${name}`).toPromise();
    localStorage.setItem(key, JSON.stringify({ time: Date.now(), data: value.data }));
    this.loadedData[name] = true;

    return value.data;
  }

  /**
   *
   * @param name
   * @param id
   * @returns
   */
  async get(name: AvailableMasterData, id: string) {
    const data = await this.getMasterData(name);

    if (data) {
      return data.filter((item) => item.id === id);
    }
  }

  async getLocation(id: string) {
    const locations = await this.getMasterData('locations');

    if (locations) {
      locations.filter((location) => location.id === id);
    }
  }

  getLocations() {
    return this.getMasterData('locations');
  }

  getCounties() {
    return this.getMasterData('counties');
  }
}
